<template>
  <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 300 300" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
    <path d="M5.1,151.6L185.2,48.3l109.1,63.1c.9.5.9,1.8,0,2.4l-178.4,102.7L5.1,151.8c0,0,0-.1,0-.2h0ZM115.9,216.4v35.3M295,112.8v35.3l-.7.9-178.4,102.7L5.1,187c0,0,0-.1,0-.2v.2-35.3M191.1,208v-34.9l-110.8-64.7M220.8,191.1v-34.9l-110.8-64.7M112.6,127.3s.6,21.3,45.7,26.7M187.2,136.3c-6.1-24.8-45.5-26.2-45.5-26.2" />
  </svg>
</template>
